<template>
	<footer class="footer">
		<div class="container">
			<div class="content has-text-centered">
				<!--  <a href="mailto:support@iridiummobile.ru">
         <span class="icon"><i class="fa fa-envelope"> support@iridiummobile.ru</i></span>
       </a> -->
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
		return this.$store.state.pkg
	}
}
</script>

<style lang="scss">
@import '~bulma/bulma';
@import '~buefy/src/scss/buefy';

.footer {
	@include mobile() {
		margin-left: 0;
	}

	.social a {
		border-bottom: none !important;
	}

	.fa.fa-heart {
		color: red;
	}
}
</style>



// WEBPACK FOOTER //
// FooterBar.vue?c12b9ba6